import { Backdrop, CircularProgress, Grid2 } from '@mui/material'
import { ReactNode, useEffect, useState } from 'react'
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom'
import { GenericError } from '@/components'
import { userSignIn } from '@/api'

interface PageWrapperProps {
  children: ReactNode
}

interface NotAvailableState {
  unauthorized: boolean
  message: string
  code: string
}

// const env = import.meta.env.VITE_ENV;
// const isProd = env === "prod";

export const PageWrapper = ({ children }: PageWrapperProps) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [notAvailable, setNotAvailable] = useState<NotAvailableState>({
    unauthorized: false,
    message: '',
    code: '',
  })
  const [searchParams, setSearchParams] = useSearchParams()
  const [hasRedirected, setHasRedirected] = useState(false)

  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const fetchToken = async () => {
      console.log(
        'response here ',
        searchParams.get('userId'),
        searchParams.get('code'),
      )

      if (searchParams.get('userId') && searchParams.get('code')) {
        localStorage.clear()

        const userId = searchParams.get('userId')!
        const code = searchParams.get('code')!

        try {
          const response = await userSignIn({ sourceUserId: userId, code })
          const httpStatus =
            response?.data?.data?.httpStatus || response?.data?.httpStatus

          if (httpStatus === 'NO_CONTENT') {
            setLoading(false)
            setNotAvailable({
              unauthorized: true,
              message: 'THIS USER COULD NOT BE FOUND',
              code: '404',
            })
            window.location.href =
              'https://3sportal.yamahamotorphilippines.com.ph/AdvancedServiceKiosks/Home'
            return
          } else if (httpStatus === 'UNPROCESSABLE_ENTITY') {
            setLoading(false)
            setNotAvailable({
              unauthorized: true,
              message: 'INVALID ACTION BAD CREDENTIALS',
              code: '422',
            })
            return
          } else if (httpStatus === 'UNAUTHORIZED') {
            setLoading(false)
            setNotAvailable({
              unauthorized: true,
              message: 'Access to this resource is currently unavailable to your account.',
              code: '401',
            })
            return
          } else {
            localStorage.setItem('userId', userId)
            localStorage.setItem('code', code)
            localStorage.setItem('name', response?.data?.data?.userName || '')
            localStorage.setItem(
              'role',
              JSON.stringify(response?.data?.data?.role || ''),
            )
            localStorage.setItem('token', response?.data?.data?.jwt || '')
            
            searchParams.delete('userId')
            searchParams.delete('code')
            setSearchParams(searchParams)

            if (!hasRedirected && location.pathname === '/') {
              const userRole = response?.data?.data?.role
              const defaultRoute =
                userRole === 'Super Admin'
                  ? '/area-management'
                  : '/maintenance-tickets'
              setHasRedirected(true)
              navigate(defaultRoute, { replace: true })
            }

            setLoading(false)
          }
        } catch (error) {
          console.log('=== ERROR CAUGHT ===')
          console.log('Full error:', error)
          console.log('Error type:', typeof error)
          console.log('Has response:', !!error?.response)

          if (error?.response) {
            const httpStatus = error.response.data?.httpStatus

            if (httpStatus === 'NO_CONTENT') {
              setLoading(false)
              setNotAvailable({
                unauthorized: true,
                message: 'THIS USER COULD NOT BE FOUND',
                code: '404',
              })
              window.location.href =
                'https://3sportal.yamahamotorphilippines.com.ph/AdvancedServiceKiosks/Home'
              return
            } else if (httpStatus === 'UNPROCESSABLE_ENTITY') {
              setLoading(false)
              setNotAvailable({
                unauthorized: true,
                message: 'INVALID ACTION BAD CREDENTIALS',
                code: '422',
              })
              return
            } else if (httpStatus === 'UNAUTHORIZED') {
              setLoading(false)
              setNotAvailable({
                unauthorized: true,
                message: 'Access to this resource is currently unavailable to your account.',
                code: '401',
              })
              return
            } else {
              console.log('>>> NO CONDITIONS MATCHED')
              console.log('httpStatus was:', JSON.stringify(httpStatus))
            }
          }

          console.log('>>> FALLBACK ERROR HANDLING')
          setLoading(false)
          setNotAvailable({
            unauthorized: true,
            message: 'AN ERROR OCCURRED DURING AUTHENTICATION',
            code: '500',
          })
        }
      } else {
        if (localStorage.getItem('token')) {
          if (!hasRedirected && location.pathname === '/') {
            const roleString = localStorage.getItem('role')
            const userRole = roleString ? JSON.parse(roleString) : ''
            const defaultRoute =
              userRole === 'Super Admin'
                ? '/area-management'
                : '/maintenance-tickets'
            setHasRedirected(true)
            navigate(defaultRoute, { replace: true })
          }
          setLoading(false)
        }
      }
    }

    fetchToken()
  }, [
    searchParams,
    setSearchParams,
    location.pathname,
    navigate,
    hasRedirected,
  ])

  if (loading) {
    return (
      <Backdrop open={loading}>
        <Grid2 rowGap={2} container justifyContent="center" alignItems="center">
          <CircularProgress color="inherit" />
        </Grid2>
      </Backdrop>
    )
  } else if (notAvailable.unauthorized) {
    return <GenericError error={notAvailable} />
  } else {
    return <Grid2>{children}</Grid2>
  }
}
